module.exports = __webpack_public_path__ + "img/T7A6685.47a438de.jpg";